import { ServiceFetch } from '../service-fetch'

export default class TeamListModel extends ServiceFetch {
    getTeamListBy = (data) => this.authFetch({
        url: 'team-list/getTeamListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}